"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Link } from "@/components/common/Link";
export default function PublicSector() {
  const heading = useRevealOnScroll<HTMLDivElement>({
    once: true,
    threshold: 0.2
  });
  const disciplines = [{
    title: "Public Funding",
    body: "InfraPM helps utilities and local governments identify, pursue, and manage public funding for critical infrastructure projects. We translate grant requirements, agency expectations, and project needs into practical applications, compliance documents, and delivery strategies that help communities move from funding opportunity to implementation.",
    href: "/Services",
    linkText: "View our services"
  }, {
    title: "Stakeholder Coordination",
    body: "InfraPM helps align local governments, utilities, engineers, funding agencies, and regional partners around clear project goals, roles, and next steps. We support practical coordination that keeps projects moving, reduces confusion, and turns technical, funding, policy compliance, public notice and community messaging needs into shared action.",
    href: "/Services",
    linkText: "View our services"
  }, {
    title: "Regional Intelligence",
    body: "InfraPM tracks public source civic, funding, policy, procurement, and capital planning signals that matter to public agencies and private-sector infrastructure teams. This intelligence helps local governments plan ahead while helping engineers, contractors, and partners identify realistic opportunities, understand local context, and prepare stronger capture strategies.",
    href: "/Services",
    linkText: "View our services"
  }];
  return <section data-section-id="15246" id="public-sector-experience" className="bg-background text-foreground font-default ![padding:0px_0px_128px_0px]">
      <div className="max-w-[1440px] mx-auto px-6 md:px-12">
        <div ref={heading.ref} className={`grid grid-cols-12 gap-x-4 md:gap-x-6 transition-all duration-[520ms] ease-[cubic-bezier(0.2,0,0,1)] ${heading.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
          <h2 className="col-span-12 md:col-span-8 font-default font-medium text-foreground" style={{
          fontSize: "clamp(2.25rem, 4.5vw, 4rem)",
          letterSpacing: "-0.02em",
          lineHeight: 0.98
        }}>Built for Public Good.</h2>
        </div>

        <div className="mt-16">
          <div className="h-px w-full bg-border" />
        </div>

        <div className="mt-16 md:mt-20 grid grid-cols-1 md:grid-cols-12 gap-x-4 md:gap-x-6 gap-y-12 md:gap-y-0">
          {disciplines.map((d, i) => {
          const col = useRevealOnScroll<HTMLDivElement>({
            once: true,
            threshold: 0.15
          });
          const delay = `${i * 60}ms`;
          return <div data-index={i} key={i} ref={col.ref} style={{
            transitionDelay: col.isVisible ? delay : "0ms"
          }} className={`md:col-span-4 transition-all duration-[480ms] ease-[cubic-bezier(0.2,0,0,1)] ${col.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"} ${i > 0 ? "md:border-t-0 border-t border-border pt-12 md:pt-0" : ""}`}>
                <h3 className="font-default font-semibold text-foreground" style={{
              fontSize: "clamp(1.125rem, 1.4vw, 1.375rem)",
              letterSpacing: "-0.005em",
              lineHeight: 1.25
            }}>
                  {d.title}
                </h3>

                <p className="mt-6 font-default font-normal text-foreground !bg-[rgba(255,255,255,1)]" style={{
              fontSize: "clamp(0.9375rem, 1vw, 1.0625rem)",
              lineHeight: 1.55
            }}>
                  {d.body}
                </p>

                <div className="mt-12">
                  <Link to={d.href} className="group inline-flex items-baseline text-foreground hover:text-primary transition-colors duration-[180ms] ease-[cubic-bezier(0.2,0,0,1)] font-default" style={{
                fontSize: "clamp(0.9375rem, 1vw, 1.0625rem)",
                lineHeight: 1.55
              }}>
                    <span className="relative pb-1.5">
                      {d.linkText}
                      <span aria-hidden="true" className="absolute left-0 right-0 bottom-0 bg-current transition-all duration-[180ms] ease-[cubic-bezier(0.2,0,0,1)] h-px group-hover:h-0.5" />
                    </span>
                  </Link>
                </div>
              </div>;
        })}
        </div>
      </div>
    </section>;
}